export default {
  install(Vue, options) {
    // Overwrite global Vue error handler
    Vue.config.errorHandler = err => {
      Vue.prototype.$addError(err);
    };

    // Overwrite global JS error handler
    window.onerror = (message, source, lineno, colno, err) => {
      Vue.prototype.$addError(err);
      // Prevent invoking the default error handler
      return true;
    };

    // Define global fn to be called within Vue instance to report errors
    Vue.prototype.$addError = err => {
      console.error(`[Global Error Handler]: ${err}: ${err.message} ${err.stack}`);
      if (typeof options.reportBug === 'function') {
        options.reportBug(err);
      }
    };
  }
};
